import { useEffect, useState } from 'react'
import { api } from 'roadie-ui'
import { Helmet } from 'react-helmet'
import Page from 'rui/widgets/Page'
import DriveSidebar from 'components/layout/DriveSidebar'
import { StaticLoader } from 'components/misc/Loader'
import HowTos from 'components/misc/HowTos'
import { useLocalization } from 'localization'

function fetchHowTos() {
  return api
    .external()
    .get(import.meta.env.REACT_APP_ROADIE_TUTORIALS_URL)
    .then((resp) => {
      if (!resp.data.version) {
        return resp.data
      } else {
        return resp.data.howTos
      }
    })
}

const HowTosPage = () => {
  const { t } = useLocalization()
  const [loading, setLoading] = useState(true)
  const [howTos, setHowTos] = useState(null)

  useEffect(() => {
    fetchHowTos().then((data) => {
      setHowTos(data)
      setLoading(false)
    })
  }, [])

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_layout_drive_sidebar_how_tos')}</title>
      </Helmet>
      {loading ? <StaticLoader /> : <HowTos data={howTos.drive} />}
    </Page>
  )
}

export default HowTosPage
